import { CSSProperties } from 'react';

const TextEllipsis: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

export {
  TextEllipsis
};
